var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"map-object",class:({ active: this.activeSelectedCountry == this.countryInfo.name },
    {
      grayed:
        this.activeSelectedCountry !== this.countryInfo.name &&
        this.activeSelectedCountry !== '',
    }),attrs:{"d":this.countryInfo.svg,"fill":this.countryInfo.fill,"stroke":"#1E1826","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"},on:{"click":function($event){return _vm.setSelectedCountry(_vm.countryInfo.name)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }